
import { defineComponent, PropType } from 'vue'
import CollapsiblePanel from '@/components/common/CollapsiblePanel.vue'
import { theme } from '@/config/styles'

interface IFaqs {
    faqs: [
        {
            question: string
            answer: string
        }
    ]
}

/**
 * Componente de faqs
 * @props {Object<IFaqs>} faqs - Objeto do tipo IFaqs contendo um array
 * de perguntas e resposta.
 */
const __default__ = defineComponent({
    props: {
        faqsInfo: Object as PropType<IFaqs>,
    },
    components: {
        CollapsiblePanel,
    },
    setup() {
        return {
            theme,
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "25b67cba": (_ctx.theme.colors.primary.lightest)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__